/**
 * Error / warning badges on a review card. Errors say why the item cannot
 * import; warnings ride along without blocking.
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FC } from 'react';
import { AlertTriangle, XCircle } from 'lucide-react';

import { cn } from '@/lib/utils';

import type { ReviewIssue } from '../validate/review-items';

const ReviewIssueBadges: FC<{ issues: ReviewIssue[] }> = ({ issues }) => {
  if (!issues.length) return null;
  return (
    <div className="space-y-0.5">
      {issues.map((issue, index) => (
        <p
          key={index}
          className={cn(
            'flex items-start gap-1 text-[10px] leading-snug',
            issue.level === 'error' ? 'text-destructive' : 'text-warning',
          )}
        >
          {issue.level === 'error' ? (
            <XCircle className="mt-px h-3 w-3 shrink-0" aria-hidden />
          ) : (
            <AlertTriangle className="mt-px h-3 w-3 shrink-0" aria-hidden />
          )}
          <span>
            {issue.level === 'error' ? `Won’t import — ${issue.message}` : issue.message}
          </span>
        </p>
      ))}
    </div>
  );
};

export default ReviewIssueBadges;
